import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page08',
  templateUrl: './armenia-page08.component.html',
  styleUrls: ['./armenia-page08.component.css']
})
export class ArmeniaPage08Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
